<template>
    <div class="flex items-center">
        <vx-dropdown :teleport="true">
            <vx-button data-test="open-actions" aria-label="Insert content" :disabled="props.disabled"
                color="transparent"
                type="button">
                <font-awesome-icon widthAuto class="text-sm"
                    :icon="faCirclePlus"></font-awesome-icon>
            </vx-button>

            <template v-slot:items>
                <vx-dropdown-item v-if="props.enableAi" data-test="ai-message" @click="emit('click:ai')">
                    <span class="flex items-center gap-1">
                        <font-awesome-icon widthAuto :icon="faWandMagicSparkles" class="text-sm"></font-awesome-icon>
                        <span>AI Message</span>
                        <experimental-pill static></experimental-pill>
                    </span>
                </vx-dropdown-item>
                <slot></slot>
                <vx-dropdown-item v-if="!props.disableSnippets"
                    data-test="snippets-action"
                    @click="emit('click:snippets')">
                    <span>
                        <font-awesome-icon widthAuto :icon="faCubes"
                            class="mr-1 text-sm"></font-awesome-icon>
                        Snippets
                    </span>
                </vx-dropdown-item>
                <vx-dropdown-item @click="emit('click:variables')">
                    <span>
                        <font-awesome-icon widthAuto :icon="faCube"
                            class="mr-1 text-sm"></font-awesome-icon>
                        Variables
                    </span>
                </vx-dropdown-item>
                <vx-popover v-if="!props.disableMedia" hover placement="right" arrow class="w-full">
                    <vx-dropdown-item
                        data-test="media-action"
                        :disabled="props.blockImages && props.blockFiles"
                        @click="emit('click:media')"
                    >
                    <span>
                        <font-awesome-icon widthAuto :icon="faImage"
                            class="mr-1 text-sm"></font-awesome-icon>
                        Media
                    </span>

                    </vx-dropdown-item>
                    <template v-if="props.blockImages && props.blockFiles" v-slot:content>Disabled by <strong>corporate.</strong></template>
                </vx-popover>
            </template>
        </vx-dropdown>
        <div v-if="!props.disableEmojis" class="w-px h-4 bg-slate-200"></div>
        <vx-button v-if="!props.disableEmojis" @click.prevent="emit('click:emojis', $event.currentTarget)"
            :disabled="props.disabled"
            color="transparent"
            type="button"
            data-test="emojis-button"
            aria-label="Insert emoji">
            <font-awesome-icon widthAuto class="text-sm"
                :icon="faFaceGrin"></font-awesome-icon>
        </vx-button>
        <slot name="append"></slot>
    </div>
</template>

<script setup>
import { faCube, faCubes, faFaceGrin, faWandMagicSparkles } from '@fortawesome/pro-regular-svg-icons';
import { faCirclePlus, faImage } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxDropdown, VxDropdownItem, VxPopover } from '@voxie/frontend-components';
import ExperimentalPill from '~/components/general/ExperimentalPill.vue';

const props = defineProps({
    disabled: Boolean,
    enableAi: Boolean,
    disableSnippets: Boolean,
    disableMedia: Boolean,
    disableEmojis: Boolean,
    blockImages: Boolean,
    blockFiles: Boolean,
});

const emit = defineEmits(['click:ai', 'click:variables', 'click:snippets', 'click:emojis', 'click:media'])
</script>
